import { z } from 'zod';
import { roleSchema, uuidSchema } from './common.js';
/** GET /me — current identity, active org, role, entitlements and flags (BP-01 §4). */
export const meSchema = z.object({
    user: z.object({
        id: uuidSchema,
        email: z.string(),
        hasPassword: z.boolean(),
        totpEnabled: z.boolean(),
    }),
    org: z.object({ id: uuidSchema, name: z.string(), slug: z.string() }).nullable(),
    role: roleSchema.nullable(),
    /** Subject/module entitlements — empty in Slice 1 (commercial layer is BP-17). */
    entitlements: z.array(z.string()),
    flags: z.record(z.boolean()),
    /** Present only while a Super Admin is impersonating. */
    impersonation: z
        .object({ impersonatorId: uuidSchema, impersonatorEmail: z.string() })
        .nullable(),
    /** D-084: the user must accept the current Customer Terms before using the app. */
    termsAcceptanceRequired: z.boolean(),
    currentTermsVersion: z.string(),
    /** D-155a: true once this org wiped its demo data; screens render live-first from then on. */
    demoDismissed: z.boolean(),
});
/** POST /me/accept-terms — the user accepts the current Customer Terms version. */
export const acceptTermsSchema = z.object({ version: z.string().trim().min(1).max(60) }).strict();
//# sourceMappingURL=me.js.map